import axios from "axios";
import baseURL from "../configs/api";

export const post_DisabledVehicleLocation = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}disabledVehicleLocation`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            userId
        }
    });
    return response.data;
}

export const put_DisabledVehicleLocation = async (uniqeid: string, isReplaced: boolean) => {
    const response = await axios({
        url: `${baseURL}disabledVehicleLocation/UpdatePaymentRequestAsPaid?uniqeid=${uniqeid}&isReplaced${isReplaced}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
    });
    return response.data;
}

export const delete_DisabledVehicleLocation = async (primaryKey: number, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}disabledVehicleLocation`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: {
            id: primaryKey,
            userId
        }
    });
    return response.data;
}

export const getDisabledVehicleLocationsByReservationId = (reservationId: number, tenantId: string) => {
    return getFetch(`disabledVehicleLocation/GetDisabledVehicleLocationsByReservation/${reservationId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}